import * as yup from "yup";
export const categorySchema = (dataValidate) =>
  yup.object().shape(dataValidate);
